import {addFeedback, createIcon, disableButton, removeFeedback, createBSModal} from './utils_element';
import {appRequest} from './utils_request';
import {getDataLine} from './utils_dataTables';
import {CallFunction} from "../../public/bundles/w3comhulk/callFunction";

export const init = () => {
    $('#dataTable').on('draw.dt', () => {
        let addButton = $('button.btn-pv.add');
        let editButton = $('button.btn-pv.edit');
        let cancelButton = $('button.btn-pv.cancel');
        let createIfNotExistButton = $('button.btn-pv-fill-in');
        let changeButton = $('button.btn-pv-change');
        let confirmButton = $('button.btn-confirm-pv');

        $('.is-disabled').find('input').attr('disabled', true);

        // Trigger in display SaisiePV via the RenderBtnEditerPV field of SaisiePV calculation view.
        addButton.off('click');
        addButton.click(e => {
            createVehiclePV(e,true);
        });

        // Trigger in display SaisiePV via the RenderBtnEditerPV field of SaisiePV calculation view.
        // When the adjudication has an adjudication price.
        editButton.off('click');
        editButton.click(e => {
            editVehiclePV(e);
        });

        // Trigger in display SaisiePV via the RenderBtnEditerPV field of SaisiePV calculation view.
        // When the adjudication has a withdrawal price.
        cancelButton.off('click');
        cancelButton.click(e => {
            cancelVehiclePV(e);
        });

        // Trigger in display ListeVenteSaisiePV via the RenderSaisiePV field of VenteHeurePV calculation view.
        createIfNotExistButton.off('click');
        createIfNotExistButton.click(e => {
            createAdjudicationIfNotExistsAndGo(e);
        });

        // Trigger in display ListeVenteSaisiePV via the RenderEditPV field of VenteHeurePV calculation view.
        changeButton.off('click');
        changeButton.click(e => {
            changePV(e);
        });

        // Trigger in display SaisiePV via the RenderConfirmPV field of SaisiePV calculation view.
        confirmButton.off('click');
        confirmButton.click(e => {
            confirmSaisiePV(e);
        });
    });
};

export const createDirectAdjudication = (rows) => {
    var callFunction = new CallFunction('createDirectAdjudication', 'fas fa-file-contract fa-2x');
    callFunction.modalBody.innerHTML = '';
    callFunction.showModal('Créer la facture');
    if (!callFunction.checkRowsLength(rows, 1)) {
        return;
    }
    callFunction.showLinesSelected(rows.length);
    var data = rows.toArray();
    callFunction.addValidateBtn(function () {
        callFunction.startLoading();
        $.ajax({
            data: {data: data},
            type: 'POST',
            url: urls.createDirectAdjudication,
            success: function (rep) {
                callFunction.modalBody.innerHTML = '';
                for (const id in rep.success) {
                    callFunction.addLineResult('Véhicule :' + id, 'success');
                }
                for (const id in rep.error) {
                    callFunction.addLineResult('Véhicule ' + id + ' : ' + rep.error[id], 'danger');
                }
                callFunction.addReloadButton();
            },
            complete: function () {
                callFunction.stopLoading();
            }
        });
    });

};

const cancelVehiclePV = (e) => {
    let dataLine = getDataLine(e),
        submitBtn = e.currentTarget,
        inputs = $(e.currentTarget.parentNode.parentNode).find('input[type=number]'),
        data = formatData(dataLine.data, inputs[0].value, inputs[1].value)
    ;
    removeInputsFeedback(inputs);
    disableFormElements(submitBtn, inputs);

    appRequest(urls.removeAdjudicationVehicle, data)
        .then(result => {
            if (!result.valid) {
                let messageError = result.hasOwnProperty('message') ? result.message : null;
                addError(submitBtn, inputs, true, 'Annuler', 'fad fa-times mr-2', messageError);
                submitBtn.disabled = false;
            } else {
                disableFormElements(submitBtn, inputs, false);
                inputs[1].value = null;
                submitBtn.innerText = 'Valider';
                submitBtn.className = 'btn btn-block btn-success';
                submitBtn.prepend(createIcon('fad fa-check mr-2'));
                $(submitBtn).unbind();
                submitBtn.onclick = (e) => createVehiclePV(e);
            }
        })
};

const editVehiclePV = (e) => {
    let dataLine = getDataLine(e),
        submitBtn = e.currentTarget,
        inputs = $(e.currentTarget.parentNode.parentNode).find('input[type=number]')
    ;
    removeInputsFeedback(inputs);

    appRequest(urls.checkUserOnAdjudication)
        .then(result => {
            const title = '<i class="fad fa-edit mt-1 mr-2"></i>Modification des données de PV';
            const lineGotoAdjudication =
                '<div class="bd-callout bd-callout-primary mx-2">' +
                    '<div class="row">' +
                        '<div class="col-7">' +
                            'Permet de modifier les frais ou les informations acheteurs' +
                        '</div> '+
                        '<div class="col-5">' +
                            '<button class="btn btn-primary btn-block" id="btn-go-to-adjudication">' +
                                '<i class="fad fa-edit mt-1 mr-2"></i> ' +
                                'Modifier' +
                            '</button>' +
                        '</div>' +
                    '</div>' +
                '</div>'
            ;
            const lineChangeAdjudication =
                '<div class="mt-3 bd-callout bd-callout-success mx-2">' +
                    '<div class="row">' +
                        '<div class="col-12 mb-2">' +
                            'Permet de modifier le prix d\'adjudication. Les informations de frais seront ' +
                            'réinitialisées, mais l\'acheteur sera conservé' +
                        '</div>' +
                    '</div>' +
                    '<div class="row">' +
                        '<div class="col-7">' +
                            '<input class="form-control" id="newAdjudication" value="' + dataLine.data['PrixAdjudication'] + '" />' +
                        '</div>' +
                        '<div class="col-5">' +
                            '<button class="btn btn-success btn-block" id="btn-change-adjudication">' +
                                '<i class="fad fa-check mt-1 mr-2"></i>' +
                                'Valider' +
                            '</button>' +
                        '</div>' +
                    '</div>' +
                '</div>'
            ;
            const lineDeleteAdjudication =
                '<div class="mt-3 bd-callout bd-callout-danger mx-2">' +
                    '<div class="row">' +
                        '<div class="col-7">' +
                            'Permet de supprimer toutes les informations du passage au procès verbal' +
                        '</div>' +
                        '<div class="col-5">' +
                            '<button class="btn btn-danger btn-block" id="btn-undo-adjudication">' +
                                '<i class="fad fa-trash-alt mt-1 mr-2"></i>' +
                                'Supprimer' +
                            '</button>' +
                        '</div>' +
                    '</div>' +
                '</div>'
            ;


            let body = lineGotoAdjudication;

            if (result.valid) {
                body += lineChangeAdjudication + lineDeleteAdjudication;
            }

            const modal = createBSModal('modalEditPV', title, body);
            document.body.appendChild(modal);

            $('#modalEditPV').modal('show');

            const goToAdjudicationButton = $('#btn-go-to-adjudication');
            const changeAdjudicationButton = $('#btn-change-adjudication');
            const undoAdjudicationButton = $('#btn-undo-adjudication');

            let fullUrl = window.location.pathname + window.location.search;
            let currentUrl = fullUrl.slice(0, fullUrl.indexOf('urlHistory') - 1);
            let previousUrl = fullUrl.slice(fullUrl.indexOf('urlHistory') + 'urlHistory'.length + 1);
            let urlHistory = '?urlHistory=' + previousUrl + '|' + currentUrl;

            goToAdjudicationButton.off('click');
            goToAdjudicationButton.click(e => {
                submitBtn = e.currentTarget;
                disableFormElements(submitBtn, []);
                window.location = urls.editAdjudicationVehicle
                    .replace('toRpDocEntryVH', dataLine.data['DocEntryVH'])
                    .replace('toRpDocEntryPV', dataLine.data['DocEntryPV'])
                    + urlHistory
                ;
            })

            changeAdjudicationButton.off('click');
            changeAdjudicationButton.click(e => {
                submitBtn = e.currentTarget;
                disableFormElements(submitBtn, []);
                let dataToSend = dataLine.data;
                dataToSend['Price'] = $('#newAdjudication').val();

                appRequest(urls.updateVehicleAdjudication, dataToSend).then(result => {
                    if (result.valid) {
                        window.location = urls.editAdjudicationVehicle
                            .replace('toRpDocEntryVH', dataLine.data['DocEntryVH'])
                            .replace('toRpDocEntryPV', dataLine.data['DocEntryPV'])
                            + urlHistory
                        ;
                    } else {
                        alert('La mise à jour n\'a pas été validée');
                    }
                })
            })

            undoAdjudicationButton.off('click');
            undoAdjudicationButton.click(e => {
                submitBtn = e.currentTarget;
                disableFormElements(submitBtn, []);

                appRequest(urls.undoVehicleAdjudication, dataLine.data)
                    .then(result => {
                    if (result.valid) {
                        window.location.reload()
                    } else {
                        alert('L\'annulation d\'adjudication n\'a pas fonctionnée');
                    }
                })
            })
        })
    ;
};

const confirmSaisiePV = (e) => {
    let dataLine = getDataLine(e);
    let submitBtn = e.currentTarget;
    disableFormElements(submitBtn,[]);

    if ($(e.currentTarget).hasClass('btn-confirm-pv')){
        appRequest(urls.confirmAdjudicationVehicle
            .replace('toRpDocEntryPV', dataLine.data['DocEntryPV'])
            .replace('toRpLineIdPV', dataLine.data['LignePV']))
            .then(result => {
                if (result.valid) {
                    $(e.currentTarget).removeClass('btn-confirm-pv');
                    $(e.currentTarget).html('<i class="fal fa-check-square fa-2x"></i>');
                } else {
                    alert('La confirmation n\'a pas été enregistrée');
                }
            })
        ;
    }
};

const changePV = (e) => {
    let urlHistory = '?urlHistory=' + window.location.pathname + window.location.search;

    let dataLine = getDataLine(e);
    window.location = urls.dissociateAdjudication.replace('toRpDocEntryPV', dataLine.data['DocEntryPV'])
        + urlHistory;
};

const createVehiclePV = (e, withCheck) => {
    let dataLine = getDataLine(e),
        submitBtn = e.currentTarget,
        inputs = $(e.currentTarget.parentNode.parentNode).find('input[type=number]'),
        data = formatData(dataLine.data, inputs[0].value, inputs[1].value),
        adjudicationPrice = inputs[0].value,
        revocationPrice = inputs[1].value;

    removeInputsFeedback(inputs);

    if (!superviseLogicalErrors(adjudicationPrice, revocationPrice, inputs)) {
        return;
    }

    if (withCheck) {
        let difference = parseInt(dataLine.data['PrixReserve'],10) - parseInt(adjudicationPrice,10);

        if (difference > 1000) {
            const idBtn = 'btn-force-' + dataLine.data['DocEntryVH'];
            const title = '<i class="fad fa-exclamation-circle mt-1 mr-2 text-danger"></i>Attention';
            const body = 'La différence entre le prix de réserve et le prix d\'adjudication est de ' + difference;
            const action =
                '<a class="btn btn-secondary text-white" data-dismiss="modal">Annuler</a>' +
                '<a href="javascript:" id="' + idBtn + '" class="btn btn-success">Ajouter au PV tout de même</a>'
            ;
            const modal = createBSModal('modalAlerteDifference',title,body,action);
            document.body.appendChild(modal);
            $('#modalAlerteDifference').modal('show');
            $('#' + idBtn).click(() => createVehiclePV(e,false));

            return;
        }
    }

    disableFormElements(submitBtn, inputs);

    let fullUrl = window.location.pathname + window.location.search;
    let currentUrl = fullUrl.slice(0, fullUrl.indexOf('urlHistory') - 1);
    let previousUrl = fullUrl.slice(fullUrl.indexOf('urlHistory') + 'urlHistory'.length + 1);
    let urlHistory = '?urlHistory=' + previousUrl + '|' + currentUrl;

    appRequest(urls.addAdjudicationVehicle, data)
        .then(result => {
            if (!result.valid) {
                addError(submitBtn, inputs, false, 'Valider', 'fad fa-check mr-2');
            } else {
                if (data['SellState'] === 'ADJ') {

                    window.location = urls.editAdjudicationVehicle
                        .replace('toRpDocEntryVH', result.vh['DocEntry'])
                        .replace('toRpDocEntryPV', result.pv['DocEntry'])
                        + urlHistory
                    ;
                } else {
                    disableFormElements(submitBtn, inputs);
                    submitBtn.innerText = 'Annuler';
                    submitBtn.className = 'btn btn-block btn-danger';
                    submitBtn.disabled = false;
                    submitBtn.prepend(createIcon('fad fa-times mr-2'));
                    $(submitBtn).unbind();
                    submitBtn.onclick = (e) => cancelVehiclePV(e);
                }
            }
        })
};

const createAdjudicationIfNotExistsAndGo = (e) => {
    let dataLine = getDataLine(e);
    let urlHistory = '&urlHistory=' + window.location.pathname + window.location.search;

    if (dataLine.data['LabelDocNumPV'] == '') {
        appRequest(urls.createAdjudication,dataLine.data)
            .then(result => {
                if(result.valid){
                    window.location = '/display/SaisiePV?LabelDocNumPV=PV-' + result.DocNumPV + urlHistory;
                } else {
                    alert(result.error);
                }
            }
        );
    } else {
        window.location = '/display/SaisiePV?LabelDocNumPV=' + dataLine.data['LabelDocNumPV'] + urlHistory;
    }
};

const superviseLogicalErrors = (adjudicationPrice, revocationPrice, inputs) => {
    if ((adjudicationPrice === '' && revocationPrice === '') || (adjudicationPrice !== '' && revocationPrice !== '')) {
        let errorMessage = (adjudicationPrice === '' && revocationPrice === '')
            ? 'Veuillez renseigner un prix.'
            : 'Veuillez renseigner un seul prix.'
        ;

        inputs.map((index, el) => {
            let message = index === 0 ? errorMessage : '';
            addFeedback(el.parentNode, 'invalid', message)
        });

        return false;
    }

    return true;
};

const disableFormElements = (submitBtn, inputs, disable = true) => {
    disableButton(submitBtn, disable);
    inputs.map((index, element) => {
        element.disabled = disable;
    });
};

const formatData = (line, adjudicationPrice, revocationPrice) => {
    line['Price'] = adjudicationPrice !== '' ? adjudicationPrice : revocationPrice;
    line['SellState'] = adjudicationPrice !== '' ? 'ADJ' : 'RET';

    return line;
};

const addError = (submitBtn, inputs, disableElement, btnText, btnIcon, message) => {
    let newMessageError = message === null ? 'Une erreur inconnue est survenue' : message;
    disableFormElements(submitBtn, inputs, disableElement);
    addFeedback(inputs[0].parentNode, 'invalid', newMessageError);
    addFeedback(inputs[1].parentNode, 'invalid');
    submitBtn.innerText = btnText;
    submitBtn.prepend(createIcon(btnIcon));
};

const removeInputsFeedback = (inputs) => {
    inputs.map((index, el) => {
        removeFeedback(el.parentNode);
    });
};



// WEBPACK FOOTER //
// ./assets/js/display_pv.js